export default {
  sign_in_title: "Inicie sesión en su cuenta",
  sign_up_title: "Cree una nueva cuenta",
  email: "Dirección de correo electrónico",
  email_required: "Por favor ingrese su dirección de correo electrónico",
  email_placeholder: "su{0}ejemplo.com",
  email_invalid: "Por favor ingrese una dirección de correo electrónico válida",
  password: "Contraseña",
  password_placeholder: "Ingrese su contraseña",
  password_required: "Por favor ingrese su contraseña",
  password_invalid:
    "La contraseña debe tener al menos 8 caracteres e incluir letras, números y caracteres especiales",
  forgot_password: "¿Olvidó su contraseña?",
  confirm_password_required: "Por favor confirme su contraseña",
  confirm_password_placeholder: "Confirmar contraseña",
  passwords_do_not_match: "Las dos contraseñas ingresadas no coinciden",
  or: "O",
  no_account: "¿No tiene cuenta?",
  have_account: "¿Ya tiene una cuenta?",
  error: "Error de inicio de sesión. Por favor verifique su correo electrónico y contraseña.",
  google_error: "Error de inicio de sesión con Google",
  x_error: "Error de inicio de sesión con X",
  linkedin_error: "Error de inicio de sesión con LinkedIn",
  google_sign_in: "Iniciar sesión con Google",
  google_sign_up: "Registrarse con Google",
  apple_sign_in: "Iniciar sesión con Apple",
  apple_sign_up: "Registrarse con Apple",
  twitter_sign_in: "Iniciar sesión con X",
  twitter_sign_up: "Registrarse con X",
  linkedin_sign_in: "Iniciar sesión con LinkedIn",
  linkedin_sign_up: "Registrarse con LinkedIn",
  aria_card: "Tarjeta de inicio de sesión",
  aria_email: "Campo de entrada de correo electrónico",
  aria_password: "Campo de entrada de contraseña",
  aria_submit: "Botón de envío",
  aria_google: "Botón de inicio de sesión con Google",
  aria_linkedin: "Botón de inicio de sesión con LinkedIn",
  aria_switch_mode: "Cambiar entre inicio de sesión/registro",
  welcome: "Bienvenido a TaxEcoBit",
  subtitle: "Plataforma de cálculo de impuestos de carbono compatible con la UE-CBAM",
  benefit1: "Cálculo preciso de impuestos de carbono con menos del 10% de margen de error",
  benefit2: "Compatible con múltiples modos de transporte y factores personalizados",
  benefit3: "Compatible con integración API",
  benefit4: "Genera informes compatibles que cumplen con los requisitos de la UE-CBAM",
  user_friendly: "Fácil de usar",
  secure_reliable: "Seguro y confiable",
  cloud_sync: "Sincronización en la nube",
  invite_code: "Código de invitación",
  invite_code_placeholder: "Por favor ingrese el código de invitación (opcional)",
  invite_code_detected: "Código de invitación detectado",
  invited_by_user: "Invitado por",
  sign_out: "Cerrar sesión",
  agreement_prefix: "Al registrarse en TaxEcoBit, acepta nuestros",
  terms: "Términos de servicio",
  and: "y",
  privacy: "Política de privacidad",
  agreement_required: "Por favor acepte primero la política de privacidad",
  complete_verification: "Por favor complete primero la verificación",
  loading_verification: "Cargando verificación...",
  verification_failed: "Error de verificación, por favor intente nuevamente",
};
